<template>
  <section id="services" class="py-24 bg-gray-50">
    <div class="max-w-6xl mx-auto text-center px-6">
      
      <!-- Escopo do Trabalho -->
      <h3 class="text-3xl font-bold text-gray-900 text-center">📌 Escopo do nosso trabalho</h3>
      <p class="text-lg text-gray-600 text-center mt-4 mb-10">
        Veja como estruturamos a nossa estratégia para maximizar seus resultados.
      </p>

      <div class="grid md:grid-cols-3 gap-10">
        <template v-for="(step, index) in steps" :key="index">
          <div class="bg-white p-6 rounded-lg shadow-lg transform transition hover:-translate-y-2 hover:shadow-2xl" data-aos="fade-up" :data-aos-delay="index * 200">
            <div class="text-blue-600 text-4xl mb-4">
              {{ step.icon }}
            </div>
            <h3 class="text-xl font-semibold text-gray-800 mb-3">{{ step.title }}</h3>
            <p class="text-gray-500">{{ step.description }}</p>
          </div>
        </template>
      </div>

    </div>
  </section>
</template>

<script setup>
const steps = [
  { icon: "⚙️", title: "Configuração de Ferramentas", description: "Implementamos as ferramentas necessárias para mensurar e otimizar os resultados." },
  { icon: "📝", title: "Elaboração de Estratégia", description: "Criamos um plano de ação personalizado para sua empresa atingir os melhores resultados." },
  { icon: "📊", title: "Criação, Análise e Otimização", description: "Desenvolvemos, monitoramos e ajustamos os anúncios para garantir alta performance." },
  { icon: "💬", title: "Suporte no WhatsApp", description: "Atendimento rápido e eficiente para esclarecer dúvidas e otimizar estratégias." },
  { icon: "📅", title: "Reuniões Bimestrais", description: "Acompanhamos seu progresso e ajustamos a estratégia para manter um crescimento constante." },
  { icon: "📑", title: "Relatórios Mensais", description: "Entregamos relatórios detalhados para acompanhar os resultados e otimizar os investimentos." },
];
</script>
